import Grid from "@mui/material/Grid2";
import React from "react";
import TabPanel from "../../../../../../../Shared/TabPanel"
import ContactTab from "../../../../../../../Shared/ContactTab";
import AddressTab from "../../../../../../../Shared/AddressTab";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import BillingMethodTab from "../../../../../../../Shared/BillingMethodTab";
import AddressSwitch from "../../../../../../../Shared/AddressSwitch";
import ContactSwitch from "../../../../../../../Shared/ContactSwitch";
import SideTabs from "./SideTabs";
import { useCarePlanBillingSideTab } from "../../../../../../../../hooks/sideTabs/useCarePlanBillingSideTab";

const name = "CareBillingDetails"
const prefix = "CarePlanBilling"

type Props = {
  parent: string
}

const CareBillingDetails: React.FC<Props> = ({ parent }) => {
  const { sideTabsIndexes, serviceAgreementBillingTab } = useCarePlanBillingSideTab()

  const debugName = `${parent}▷[${name}]`
  useDebugInformation(debugName, { name, prefix, serviceAgreementBillingTab })
  return (
    <Grid container >
      <SideTabs parent={parent} />
      <TabPanel parent={debugName} value={serviceAgreementBillingTab} index={sideTabsIndexes.CONTACT_SIDE_TAB} style={{ marginBottom: 12, minHeight: 345 }} >
        <ContactTab parent={name} prefix={`${prefix}Contact`} >
          <ContactSwitch parent={debugName} prefix={`${prefix}Contact`} />
        </ContactTab>
      </TabPanel>
      <TabPanel parent={debugName} value={serviceAgreementBillingTab} index={sideTabsIndexes.ADDRESS_SIDE_TAB} style={{ marginBottom: 12, minHeight: 345 }} >
        <AddressTab parent={debugName} prefix={`${prefix}Address`}  >
          <div style={{ display: "flex" }}>
            {/* <BusinessSwitch parent={debugName} prefix={prefix} /> */}
            <AddressSwitch parent={debugName} prefix={`${prefix}Address`} />
          </div>
        </AddressTab>
      </TabPanel>
      <TabPanel parent={debugName} value={serviceAgreementBillingTab} index={sideTabsIndexes.BILLING_METHOD_SIDE_TAB} style={{ marginBottom: 12, minHeight: 345 }} >
        <BillingMethodTab parent={debugName} prefix={prefix} />
      </TabPanel>

    </Grid>
  );
};

export default CareBillingDetails;
